module.exports = "<list-view\n  active-params=\"$ctrl.activeParams\"\n  filter-event=\"$ctrl.filterEvent\"\n  sort-event=\"$ctrl.sortEvent\"\n  resource=\"Country\"\n  item-state=\"country\"\n  title=\"Countries\"\n  transformer=\"CountriesTransforms\"\n  paginate-event=\"$ctrl.paginateEvent\"\n  no-items-text=\"No Countries Yet!\"\n></list-view>\n\n<main-footer></main-footer>\n<main-sidenav sections=\"$ctrl.sections\">\n  <main-sidenav></main-sidenav>\n</main-sidenav>\n";


//////////////////
// WEBPACK FOOTER
// ./src/pages/countries/countries.html
// module id = 2127
// module chunks = 0